<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

// Try to load user on app mount if token exists
onMounted(async () => {
  if (authStore.token) {
    try {
      await authStore.refreshUser()
    } catch (error) {
      // Token invalid, will be handled by interceptor
      console.error('Failed to refresh user:', error)
    }
  }
})
</script>

<template>
  <RouterView />
</template>

<style>
/* Global styles are in main.css */
</style>
